
import { createContext } from "react";

import { GetUserResponse, User } from "../../api/dtos/dtos";
import { useGetUser } from "../../hooks/auth/useGetUser";

export interface IAuthContext extends Omit<ReturnType<typeof useGetUser>, 'data' | 'total' | 'offset'> {
    user: User | null,
    isLogin: boolean;
    loginMessage: string | undefined;
    openLogin: () => void;
    closeLogin: () => void;
    authenticate: (username: string, password: string) => Promise<boolean>;
    refresh: () => Promise<GetUserResponse | undefined>;
    logout: () => Promise<boolean>;
};

export const AuthContext = createContext<IAuthContext>({
    user: null,
    loading: false,
    validating: false,
    error: undefined,
    mutate: async () => { return undefined },
    refresh: async () => { return undefined },
    isLogin: false,
    loginMessage: undefined,
    openLogin: () => {},
    closeLogin: () => {},
    authenticate: async () => false,
    logout: async () => false
});

export default AuthContext;